/*
 * @Author: Q in
 * @Date: 2025-04-28 10:10:42
 * @LastEditors: Q in 
 * @LastEditTime: 2026-07-02 16:10:16
 * @FilePath: /yihao_web/src/store/index.js
 * @Description: vuex
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Router from '@/router/admin/index';
import createPersistedState from 'vuex-persistedstate';
import globalMixin from '@/mixins/admin-socket-chat.js';
import { resetWebSocket } from '@/utils/websocket.js';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		// 侧边栏列表
		asideList: [
			{
				id: 1,
				icon: 'icon-shouye',
				title: '首页',
				path: '/home.html'
			},
			{
				id: 2,
				icon: 'icon-a-kefufenxiermaikefu',
				title: '客服管理',
				path: '/serviceManagement.html'
				// auth: ['admin']
			},
			{
				id: 3,
				icon: 'icon-jichugongneng',
				title: '用户管理',
				path: '/userManagement.html'
			},
			{
				id: 4,
				icon: 'icon-zidonghuifu',
				title: '知识库',
				path: '/knowledgeBase.html'
			}
			// {
			// 	id: 4,
			// 	icon: 'icon-gongdan',
			// 	title: '工单管理',
			// 	path: '/workOrder.html',
			// },
		],
		// 当前选中的tab
		activeTab: 1,

		// 登录用户信息
		userInfo: {}
	},

	getters: {
		// 获取侧边栏列表
		getAsideList: (state) => state.asideList,
		// 获取当前选中的tab
		getActiveTab: (state) => state.activeTab,
		// 获取登录用户信息
		getUserInfo: (state) => state.userInfo
	},

	mutations: {
		// 设置当前选中的tab
		setActiveTab(state, tab) {
			if (state.activeTab == tab.id) return;
			state.activeTab = tab.id;
			Router.push(tab.path);
		},

		// 用于切换tab时，不刷新页面
		setActiveActiveTab(state, tab) {
			state.activeTab = tab.id;
		},

		// 设置登录用户信息
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
			// state.userInfo = {
			//     ...userInfo,
			//     auth: userInfo.user_id == 2 ? 'admin' : ''
			// };
			localStorage.setItem('token', userInfo.token);
		},

		// 清除登录用户信息
		clearLoginInfo(state) {
			state.userInfo = {};
			state.activeTab = 1;
			window.localStorage.clear();
			globalMixin.state.adminSocket?.close();
			globalMixin.state.adminSocket = null;
			globalMixin.state.wsConnected = false;
			// 重置 WebSocket 实例
			resetWebSocket(false, 'admin'); // 已经手动 close() 了，所以这里传 false
			Router.replace('/login.html');
		}
	},

	actions: {},

	plugins: [
		// createPersistedState({
		// 	// 排除 socket、chat 模块（运行时状态，不需要持久化）
		// 	reducer: (state) => {
		// 		const { ...rest } = state;
		// 		return rest;
		// 	},
		// 	key: 'vuex', // 存储的键名
		// 	storage: window.localStorage // 存储方式
		// })
        createPersistedState({
			// 仅持久化 userInfo（登录态）
			// asideList 是静态配置、activeTab 是 UI 状态，均不持久化
			// 这样修改 asideList（如注释掉某项）后能立即生效，不会被旧 localStorage 覆盖
			reducer: (state) => ({
				userInfo: state.userInfo
			}),
			key: 'vuex', // 存储的键名
			storage: window.localStorage // 存储方式
		})
	],

	modules: {}
});

export default store;
